import { Component, Input } from '@angular/core';
import { AppModule } from '../../../app-module';


@Component({
    selector: 'oaj-waiting-dialog',
    templateUrl: './waitingDialog.component.html',
    styleUrls: ['./waitingDialog.component.css'],
    imports: [AppModule]
})

export class WaitingDialog {
    @Input() message = 'Por favor, espere...';

}


